/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XCircleIcon20Solid = forwardRef('XCircleIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7.818 6.404a1 1 0 0 0-1.414 1.414L8.586 10l-2.182 2.182a1 1 0 1 0 1.414 1.414L10 11.414l2.182 2.182a1 1 0 0 0 1.414-1.414L11.414 10l2.182-2.182a1 1 0 0 0-1.414-1.414L10 8.586 7.818 6.404Z" })));
});
